import { isTestLink, pxChangeVw } from "@/utils";
import classNames from "classnames";
import lodash from "lodash";
import { nanoid } from "nanoid";
import { Fragment } from "react";

interface AccordionItem {
  id?: string;
  isExpand: boolean;
  isWarning?: boolean;
}

interface AccordionProps {
  list: AccordionItem[];
  setLocalList: Function;
  renderTitle: Function;
  renderContent: Function;
}
const Accordion: React.FC<AccordionProps> = ({ list, setLocalList, renderContent, renderTitle }) => {
  const panelRefs: any[] = [];
  useEffect(() => {
    if (list.length > 0) {
      const newList = [...list];
      newList[0].isExpand = true;
      const panel = panelRefs[0].current;
      panel.style.maxHeight = panel.scrollHeight + "px";
      if (window.location.pathname === "/home/detail") {
        panel.style.maxHeight = "none";
      }
      setLocalList(() => newList);
    }
  }, [list.length]);
  const closeAccordion = () => {
    list.forEach((item: { isExpand: boolean }, index: number) => {
      item.isExpand = false;
      panelRefs[index].current.style.maxHeight = "";
    });
  };
  const handleClick: any = async (item: any, index: number) => {
    const clickItem: any = list.find((object: { id?: string }) => object.id === item.id);
    if (clickItem?.isExpand) {
      closeAccordion();
    } else {
      closeAccordion();
      clickItem.isExpand = true;
      const panel = panelRefs[index].current;
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
    setLocalList(() => [...list]);
  };

  const isDomainValid = (index: number, listLength: number): boolean => {
    const testDomains = lodash.flatten(Object.values(lodash.omit(domainMap, ["wi"])));
    return (
      (isTestLink(testDomains) && index === 0 && list[0].isExpand) ||
      (index === 0 && list[0].isExpand && testDomains.includes(window.location.hostname)) ||
      (index !== 0 &&
        index % 3 === 0 &&
        index !== listLength - 1 &&
        (isTestLink(testDomains) || testDomains.includes(window.location.hostname)))
    );
  };

  const GoogleAdWrapper = ({ index, listLength }: { index: number; listLength: number }) => {
    if (!isDomainValid(index, listLength)) return null;

    const adProps = useGoogleAd("300x250", index === 0 ? 0 : 1);
    return <GoogleAd {...adProps} />;
  };

  return (
    <div className="flex flex-col justify-start gap-y-10">
      {!!list.length &&
        list.map((item: any, index: number) => {
          panelRefs[index] = useRef<any>(null);
          item.id ??= nanoid(16);
          return (
            <Fragment key={index}>
              <div>
                <WeatherMainContent
                  className={classNames([
                    "content",
                    item.isWarning ? "border-l-3 border-l-solid border-l-[#ff534e]" : "",
                  ])}
                >
                  <div className="flex flex-col" style={{ rowGap: item.isExpand ? pxChangeVw("10px") : "" }}>
                    {renderTitle && renderTitle(item, index, handleClick)}
                    <div className="max-h-0 overflow-hidden" ref={panelRefs[index]}>
                      {renderContent && renderContent(item, index)}
                    </div>
                  </div>
                </WeatherMainContent>
              </div>
              <GoogleAdWrapper index={index} listLength={list.length} />
            </Fragment>
          );
        })}
    </div>
  );
};
export default Accordion;
